import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Modal, ModalBody } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import s3 from './sms.sass';

import imgLoadingSmall from '../../assets/img/icon_loading_small.png';
import imgLoadingSmall2 from '../../assets/img/icon_loading_small@2x.png';

class smsVerifyLoadingDialog extends React.Component {
  static propTypes = {
    // currentLocale: PropTypes.string.isRequired,
    modal: PropTypes.bool.isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };

  render() {
    return (
      <div id="blacklist">
        <Modal
          className={`${s2.dialog} ${s2.infoPopup}`}
          isOpen={this.props.modal}
          // isOpen
        >
          <ModalBody
            className={`${s2.smsContainer} ${s3.smsContainer} ${s3.smsError}`}
            style={{ padding: 0 }}
          >
            <p className={`${s.globalTextBlue} ${s3.smsStatus}`}>
              {this.props.modelDataText.sms_verifying}&nbsp;
              <img
                className={s.graphsRotate}
                srcSet={`${imgLoadingSmall} 1x, ${imgLoadingSmall2} 2x`}
                width="30"
                height="30"
                alt="loading"
              />
            </p>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.dialog.isShowSMSVerifyLoadingDialog,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(smsVerifyLoadingDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/smsVerifyLoadingDialog.js